import { createFileRoute } from '@tanstack/react-router';
import { RoutineForm } from '@/components/insights/RoutineForm.tsx';

export const Route = createFileRoute('/_app/insights/routines/new')({
  staticData: { orgScope: 'none' },
  component: () => <RoutineForm />,
});
